'use strict';

const jQuery = require('jquery');

const DndZone = require('./dndZone');
const ContentManager = require('./../component/ContentManager');
const SaveManager = require('./../component/SaveManager');
const Plugin = require('./../plugin');

let currentMousePosition;
let isDisabled = false;

const unApply = function() {
    jQuery('.cloud-column-resize').remove();
};

const getColMdClass = function(classes = '') {
    let classnames = classes.split(' ');

    for (let classname of classnames) {
        if (classname.substring(0, 6) === 'col-lg') {
            return classname;
        }
    }

    return '';
};

const calculColumns = function($colContentSet, direction) {
    let $col = $colContentSet.parent();
    let currentCol = parseInt(getColMdClass($col.attr('class')).substring(7), 10);
    let newCol = currentCol + (direction === 'right' ? 1 : -1);

    let $rightCol = $col.next().next();
    let currentRightCol = parseInt(getColMdClass($rightCol.attr('class')).substring(7), 10);
    let newRightCol = currentRightCol + (direction === 'right' ? -1 : 1);

    let currentCols = 0;
    let $siblings = $col.siblings(':not(.cloud-dnd, .cloud-dnd-content)');

    $siblings.each(function() {
        let $current = jQuery(this);

        if (!$current.is($col) && !$current.is($rightCol)) {
            currentCols = currentCols + parseInt(getColMdClass($current.attr('class')).substring(7), 10);
        }
    });

    let maxCols = 12 - currentCols;

    $col.addClass('resize-wrapper');
    $rightCol.addClass('resize-wrapper');

    if (newCol >= 2 && newCol < maxCols && newRightCol >= 2 && newRightCol < maxCols) {
        $col.removeClass(`col-lg-${currentCol}`).addClass('col-lg-' + newCol);
        $rightCol.removeClass(`col-lg-${currentRightCol}`).addClass('col-lg-' + newRightCol);
    }
};

const resize = function(e) {
    let $target = jQuery(e.data.stick);
    let direction = (currentMousePosition && currentMousePosition > e.clientX) ? 'left' : 'right';

    e.preventDefault();

    jQuery('body').addClass('column-resize prevent-plugins');

    if (direction === 'left') {
        if (currentMousePosition - e.clientX >= 20) {
            currentMousePosition = e.clientX;
            calculColumns($target.parents('.colcontentset:first'), direction);
        }
    } else {
        if (e.clientX - currentMousePosition >= 20) {
            currentMousePosition = e.clientX;
            calculColumns($target.parents('.colcontentset:first'), direction);
        }
    }
};

const stopResize = function(e) {
    let $stick = jQuery(e.data.stick);
    let cloudContentSet = ContentManager.getContentByNode($stick.parents('.cloudcontentset:first'));
    let $colContentSet = $stick.parents('.colcontentset:first');
    let $col = $colContentSet.parent();
    let $rightCol = $col.next().next();

    $col.removeClass('resize-wrapper');
    $rightCol.removeClass('resize-wrapper');

    $stick.parents('.row:first').find('.resize-wrapper-element').remove();

    e.preventDefault();

    jQuery('body').removeClass('column-resize prevent-plugins');

    let data = [];
    cloudContentSet.$.find('.row:first').children().not('.cloud-dnd, .cloud-column-resize, .cloud-dnd-content').each(function() {
        data.push(parseInt(getColMdClass(jQuery(this).attr('class')).substring(7), 10));
    });

    cloudContentSet.addParameter('blocksize', data);

    SaveManager.save();

    jQuery(window).off('mousemove.resizecol');
    jQuery(window).off('mouseup.resizecol');

    DndZone.apply();
    apply();
};

const initResize = function(e) {
    currentMousePosition = e.clientX;

    e.preventDefault();

    let $row = jQuery(e.target).parents('.row:first');
    let $children = $row.find('[class^="col-lg"]');

    $children.each(function() {
        jQuery(this).append('<div class="resize-wrapper-element"></div>');
    });

    let $fixedElement = jQuery('.bb-content.fixed');
    if ($fixedElement.length) {
        Plugin.onMouseLeave(ContentManager.getContentByNode($fixedElement));
    }

    jQuery(window).on('mousemove.resizecol', {'stick': e.target}, resize);
    jQuery(window).on('mouseup.resizecol', {'stick': e.target}, stopResize);
};

const apply = function() {
    if (isDisabled) {
        return;
    }

    unApply();

    jQuery('.cloudcontentset').each(function() {
        let $cloudContentSet = jQuery(this);
        let $row = $cloudContentSet.find('.row:first');
        let $colContentSets = $cloudContentSet.find('.colcontentset');
        let length = $colContentSets.length;

        if (length > 1) {
            $colContentSets.each(function(key) {
                if ((key + 1) < length) {
                    let $colContentSet = jQuery(this);
                    let $content = $colContentSet.find('.bb-content:first');
                    let $tpl = jQuery('<div class="cloud-column-resize"></div>');

                    if (!$content.length) {
                        return;
                    }

                    let height = $row.height() - parseInt($content.css('margin-bottom').replace('px', ''), 10);

                    $tpl.css('height', height + 'px');

                    $tpl.on('mousedown.resizecol', initResize);

                    $colContentSet.append($tpl);
                }
            });
        }
    });
};

module.exports.disable = () => {
    isDisabled = true;
    unApply();
};
module.exports.enable = () => {
    isDisabled = false;
    apply();
};
module.exports.unApply = unApply;
module.exports.apply = apply;
